import { ButtonProps } from '@cp/ds/src/components/button/model';
import { ClientSelection } from 'src/entities/client';

export enum FavoriteVariant {
  text = 0,
  icon = 1,
}

export interface FavoriteProps extends Omit<ButtonProps, 'variant'> {
  authorId: number;
  variant?: FavoriteVariant;
  clientSelection?: ClientSelection;
}
